/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FunctionComponent } from 'react';
import { format } from 'date-fns';
import { Symbol, Skeleton } from '@doveit/lego';
import * as styles from './ReviewCard.style';
import { TRUSTPILOT_STAR } from '../../themes/icons';
import { requireFromStaticAsset } from '../../utils/assetsUtils';

export const ReviewCardSkeleton: FunctionComponent = () => (
  <article
    css={styles.base}
  >
    <header css={styles.header}>
      <Skeleton count={2} />
    </header>
    <div css={styles.review}>
      <Skeleton height="10rem" />
    </div>
    <footer css={styles.footer}>
      <div css={styles.stars}>
        <Skeleton width="10rem" />
      </div>
    </footer>
  </article>
);

export interface ReviewCardProps {
  author: string,
  date: string,
  rating: number,
  review: string,
  onClick?: VoidFunction,
}

const ReviewCard: FunctionComponent<ReviewCardProps> = ({
  author,
  date,
  rating,
  review,
  onClick,
}) => (
  <article
    aria-label="Recensione TrustPilot"
    css={styles.base}
    onClick={onClick}
    $clickable={!!onClick}
  >
    <header css={styles.header}>
      <div>
        {author}
      </div>
      <time>
        {format(new Date(date), 'dd/MM/yyyy')}
      </time>
    </header>
    <div css={styles.review}>
      {review}
    </div>
    <footer css={styles.footer}>
      <div css={styles.logo}>
        <img src={requireFromStaticAsset('trustpilot/logo.svg')} alt="Logo Trustpilot" />
      </div>
      <div css={styles.stars}>
        {[1, 2, 3, 4, 5].map((index) => (
          <div
            key={index}
            css={styles.star}
            $full={index <= rating}
          >
            <Symbol
              path={TRUSTPILOT_STAR}
              size={22}
            />
          </div>
        ))}
      </div>
    </footer>
  </article>
);

export default ReviewCard;
